import { render, staticRenderFns } from "./OrganizationHeader.vue?vue&type=template&id=7fbc83f4&"
import script from "./OrganizationHeader.vue?vue&type=script&lang=js&"
export * from "./OrganizationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports